import { render, staticRenderFns } from "./switch-user.vue?vue&type=template&id=b96538c8&scoped=true"
import script from "./switch-user.vue?vue&type=script&lang=js"
export * from "./switch-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96538c8",
  null
  
)

export default component.exports